module.exports = 'ailos_prod';
